import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert, Paper } from "@mui/material";
import axios from "axios";

export default function ChangePasswordForm({ onSuccess }) {
	const [oldPassword, setOldPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError("");
		setSuccess("");
		const URL = `${process.env.REACT_APP_BACKEND_URL}/api/users/change-password`;
		try {
			const token = localStorage.getItem("token");
			await axios.post(URL, { oldPassword, newPassword }, { headers: { Authorization: `Bearer ${token}` } });
			setSuccess("Ο κωδικός άλλαξε επιτυχώς.");
			setOldPassword("");
			setNewPassword("");
			if (onSuccess) onSuccess();
		} catch (err) {
			setError(err.response?.data?.error || "Σφάλμα αλλαγής κωδικού. Προσπαθήστε ξανά.");
		}
		setLoading(false);
	};

	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
			<Paper elevation={3} sx={{ p: 4, minWidth: 320 }}>
				<Typography variant="h5" mb={2} align="center">
					Αλλαγή Κωδικού
				</Typography>
				<form onSubmit={handleSubmit}>
					<TextField
						label="Παλιός κωδικός"
						type="password"
						value={oldPassword}
						onChange={(e) => setOldPassword(e.target.value)}
						fullWidth
						margin="normal"
						required
					/>
					<TextField
						label="Νέος κωδικός"
						type="password"
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
						fullWidth
						margin="normal"
						required
					/>
					{error && (
						<Alert severity="error" sx={{ mt: 2 }}>
							{error}
						</Alert>
					)}
					{success && (
						<Alert severity="success" sx={{ mt: 2 }}>
							{success}
						</Alert>
					)}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						sx={{ mt: 2 }}
						disabled={loading}
					>
						Αλλαγή Κωδικού
					</Button>
				</form>
			</Paper>
		</Box>
	);
}
